import { connect } from 'react-redux'
import CommentMetadataForm from '../presentation/view_document_page/CommentMetadataForm'

const mapStateToProps = (state) => {
    let metadata = null;
    if (state.documents !== null && state.documents.metadata !== null) 
        metadata = state.documents.metadata;
    return {
        parentMetadata: metadata,
        strings: state.i18.strings
    };
}

const mapDispatchToProps = (dispatch) => {
    return {};
}

const CommentMetadataFormView = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CommentMetadataForm)

export default CommentMetadataFormView;